import { useEffect, useState } from "react";
import { RangeTimeValue } from "../types";

export const useRecentRanges = (maxRanges = 5) => {
  const [recentRanges, setRecentRanges] = useState<RangeTimeValue[]>(() => {
    const stored = localStorage.getItem('recentDateRanges');
    if (!stored) return [];

    try {
      return JSON.parse(stored).map(({ start, stop }: { start: string; stop: string }) => ({
        start: start,
        stop: stop,
      }));
    } catch {
      return [];
    }
  });

  useEffect(() => {
    const toStore = recentRanges.slice(0, maxRanges).map(({ start, stop }) => ({
      startDate: start,
      endDate: stop ?? null,
    }));

    localStorage.setItem('recentDateRanges', JSON.stringify(toStore));
  }, [recentRanges, maxRanges]);

  const addRange = (range: RangeTimeValue) => {
    setRecentRanges((prev) => {
      const filtered = prev.filter((r) => r.start !== range.start || r.stop !== range.stop);
      return [range, ...filtered];
    });
  };

  return { recentRanges, addRange };
}